module.exports = __webpack_public_path__ + "img/wenskaarten-kerstkaarten-kerst-papette-quotes-3.1be0dfc2.jpg";